import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { useMedia } from '@/hooks';
import { hasTranslation } from '@/modules/localization';
import { replaceFsCount, useButtonAction } from '@/modules/promo';
import { useFsCountFromQuery } from '@/modules/promo/hooks/useFsCountFromQuery';
import { DEFAULT_IMG_SRC, themeConfig } from './helpers';
import { ScStepsLanding } from './styled';

type TColorScheme = 'yellow' | 'blue' | 'lightBlue';

interface IStepsLanding {
  translation: string;
  colorScheme?: TColorScheme;
  assetsSrc?: string;
}

export const StepsLanding: FC<IStepsLanding> = ({
  translation,
  colorScheme = 'yellow',
  assetsSrc,
}) => {
  const { t } = useTranslation(translation);
  const { isMobile } = useMedia();
  const { buttonAction } = useButtonAction();
  const themes = themeConfig[colorScheme];

  const getImgSrc = (img: string) => {
    const src = assetsSrc ? assetsSrc : DEFAULT_IMG_SRC;
    const formatSrc = assetsSrc ? '.webp' : '.svg';
    return `${src}${img}${formatSrc}`;
  };

  const fsCount = useFsCountFromQuery();

  return (
    <ScStepsLanding colorScheme={colorScheme} themes={themes}>
      {Array.from({ length: 3 }).map((_, index) => (
        <React.Fragment key={index}>
          <div className="step" {...buttonAction}>
            <div className="content">
              <ImageComponent
                alt={`step-${index}`}
                height={64}
                src={getImgSrc(`step-${index + 1}`)}
                width={64}
              />
              <div className="benefit">
                {hasTranslation(t, `step${index + 1}.title`) && (
                  <p className="title">{t(`step${index + 1}.title`)}</p>
                )}
                <p className="description">
                  {index === 2
                    ? replaceFsCount(t(`step${index + 1}.description`), fsCount)
                    : t(`step${index + 1}.description`)}
                </p>
              </div>
              {isMobile && (
                <ImageComponent
                  alt="arrow"
                  height={24}
                  src={getImgSrc('arrow')}
                  width={72}
                />
              )}
            </div>
          </div>

          {!isMobile && index < 2 && (
            <ImageComponent
              alt="arrow"
              height={24}
              src={getImgSrc('arrow')}
              width={72}
            />
          )}
        </React.Fragment>
      ))}
    </ScStepsLanding>
  );
};
